import { IGroupDTOIn } from '../interfaces/groups/group.interface';

export const mockGroups: IGroupDTOIn[] = [
    {
        id: 5000,
        education_level_ids: [1],
        name: 'Corps enseignant - primaire',
        is_active: true,
        school_year_id: 1,
        member_ids: [3],
        users: [],
        school_id: 1,
    },
    {
        id: 5001,
        education_level_ids: [1],
        name: 'Association des parents - primaires',
        is_active: true,
        school_year_id: 1,
        member_ids: [2],
        users: [],
        school_id: 1,
    },
    {
        id: 5002,
        education_level_ids: [2],
        name: 'Corps enseignant - maternelle',
        is_active: true,
        school_year_id: 1,
        member_ids: [3],
        users: [],
        school_id: 1,
    },
    {
        id: 5003,
        education_level_ids: [2],
        name: 'Association des parents - maternelle',
        is_active: true,
        school_year_id: 1,
        member_ids: [2],
        users: [],
        school_id: 1,
    },
];
